import React, { FC, useMemo } from 'react';
import { nullSafeGet } from '../../utils/DataAccessUtils';
import { connect } from 'react-redux';
import { getProtectedImageUriFromString } from '../../utils/FileAccessUtils';

export const BRAND_DISPLAY_TYPE = {
	WO_CREATION: 'WO_CREATION',
	WO_PRINTABLE: 'WO_PRINTABLE',
	LOCATION_CARD: 'LOCATION_CARD',
};

const BrandLogoDisplay: FC<any> = ({
	brand,
	userType,
	displayType,
	onLoad = () => {},
}): React.ReactElement => {
	const logoUrl = useMemo(
		() =>
			nullSafeGet('logoAttachment.fileId', brand)
				? getProtectedImageUriFromString(userType)(
						`${brand.logoAttachment.fileId}/${brand.logoAttachment.fileName}`,
						600,
						600
				  )
				: '',
		[brand, userType]
	);

	const displayClassName = useMemo(() => {
		switch (displayType) {
			case BRAND_DISPLAY_TYPE.WO_CREATION:
				return 'mr-2 h-8  w-auto lg:mb-2 lg:h-auto lg:w-20';
			case BRAND_DISPLAY_TYPE.LOCATION_CARD:
				return 'h-auto w-20 object-contain';
			case BRAND_DISPLAY_TYPE.WO_PRINTABLE:
			default:
				return 'mr-3 h-auto w-16 object-contain';
		}
	}, [displayType]);

	return logoUrl ? (
		<img
			src={logoUrl}
			alt={nullSafeGet('brandName', brand)}
			className={displayClassName}
			onLoad={onLoad}
		/>
	) : null;
};

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(BrandLogoDisplay);
